import { useState, useEffect } from "react";
import { Table, Input } from 'reactstrap';
import ReactTooltip from "react-tooltip";
import Select from "./Select";
import Integer from "./Integer";
import sortObjectsArray from 'sort-objects-array';
import DateField from "./DateField";
import Decimal from "./Decimal";

function MultiInput(props) {

    let [items, updateItems] = useState();
    let [form, updateForm] = useState();

    useEffect(() => {
        updateForm(props.form ? props.form : {});
        if (props.value) {
            let value = sortObjectsArray(props.value, 'index');
            updateItems(value);
        } else {
            let tempItem = {};
            let tempItems = [];
            props.form.forEach((element, index2) => {
                tempItem[element.name] = '';
            });
            tempItems.push(tempItem);
            updateItems(tempItems);
        }

    }, []);

    const handleChange = async (event, item, index, input) => {
        let tempItems = [];
        items.forEach((element, index2) => {
            if (index == index2) {
                switch (input.type) {
                    case 'select':
                        element[input.name] = {
                            label: event.target.label,
                            value: event.target.value
                        };
                        break;
                    default:
                        element[input.name] = event.target.value;
                        break;
                }

            }
            tempItems.push(element);
        });

        if (event.target.value != '' && props.sortBy == input.name) {
            tempItems = sortObjectsArray(tempItems, props.sortBy);
            updateItems([]);
            await setTimeout(() => {
                updateItems(tempItems);
            }, 100)
        } else {
            updateItems(tempItems);
        }

        props.onChange({
            target: {
                name: props.name,
                value: items
            }
        });
    };

    const clickAdd = () => {
        let tempItem = {};
        let tempItems = [];

        items.forEach((element, index) => {
            tempItems.push(element);
        });

        form.forEach((element, index) => {
            tempItem[element.name] = '';
        });
        tempItems.push(tempItem);
        updateItems(tempItems);

        props.onAdd({
            target: {
                name: props.name,
                value: tempItems
            }
        });
    }

    const onDelete = index => {
        if (items.length > 1) {
            let tempItems = [];

            items.forEach((element, index2) => {
                if(index2 != index){
                    tempItems.push(element);
                }
            });
            
            updateItems(tempItems);

            props.onDelete({
                target: {
                    name: props.name,
                    value: tempItems
                }
            });
        }
    }

    return (
        <>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        {form && form.map(item => {
                            return (
                                <th style={item.styleTh}>
                                    {item.label}
                                </th>
                            )
                        })
                        }
                        <th>Excluir</th>
                    </tr>
                </thead>
                <tbody>
                    {items && items.map((element, index) => {
                        return (
                            <tr>
                                {form && form.map(item => {
                                    switch (item.type) {
                                        case 'text':
                                            return (
                                                <td>
                                                    <Input
                                                        onChange={event => { handleChange(event, element, index, item) }}
                                                        value={items[index][item.name]}
                                                        type='text'
                                                        name={item.name}
                                                        maxLength={item.maxLength ? item.maxLength : 20}
                                                        readOnly={props.readOnly}
                                                    />
                                                </td>
                                            )
                                            break;
                                        case 'select':
                                            return (
                                                <td>
                                                    <Select
                                                        name={item.name}
                                                        value={items[index][item.name]}
                                                        onChange={event => { handleChange(event, element, index, item) }}
                                                        options={item.options}
                                                        optionsEndpoint={item.optionsEndpoint}
                                                        disabled={props.readOnly}
                                                    />
                                                </td>
                                            )
                                            break;
                                        case 'integer':
                                            return (
                                                <td>
                                                    <Integer
                                                        name={item.name}
                                                        value={items[index][item.name]}
                                                        onChange={event => { handleChange(event, element, index, item) }}
                                                        maxLength={item.maxLength ? item.maxLength : 20}
                                                        readOnly={props.readOnly}
                                                    />
                                                </td>
                                            )
                                            break;
                                            case 'date':
                                                return (
                                                    <td>
                                                        <DateField
                                                            name={item.name}
                                                            onChange={event => { handleChange(event, element, index, item) }}
                                                            value={items[index][item.name]}
                                                            options={item.options}
                                                            readOnly={item.readOnly ? true : false}
                                                        />
                                                    </td>
                                                )
                                            break;
                                            case 'decimal':
                                                return (
                                                    <td>
                                                        <Decimal
                                                            type="text"
                                                            name={item.name}
                                                            onChange={event => { handleChange(event, element, index, item) }}
                                                            value={items[index][item.name]}
                                                            maxLength={item.maxLength ? item.maxLength : 100}
                                                            readOnly={item.readOnly ? true : false}
                                                            autoFocus={item.autoFocus}
                                                        />
                                                    </td>
                                                )
                                            break;
                                    }

                                })
                                }
                                <td style={{ width: '5%' }} >
                                    {!props.readOnly && (
                                        <div className="d-flex justify-content-center">
                                            <a
                                                className="btn btn-danger btn-sm btn-action"
                                                onClick={() => { onDelete(index) }}
                                                data-tip data-for={"tooltip-delete-" + index}
                                                data-testid={`excluir-${index}`}
                                            >
                                                <i className="fas fa-trash">
                                                </i>
                                            </a>
                                            <ReactTooltip id={"tooltip-delete-" + index} place="top" effect="solid">
                                                Excluir
                                            </ReactTooltip>
                                        </div>
                                    )}

                                </td>
                            </tr>
                        )

                    })}
                </tbody>
            </Table>
            {!props.readOnly && (
                <div className="d-flex justify-content-center">
                    <button onClick={clickAdd} type="button" className="btn btn-secondary" style={{ marginRight: '10px' }}>
                        Adicionar
                    </button>
                </div>
            )}
        </>

    );
}
export default MultiInput;